import React from 'react';
import MaterialListItemButton from '@mui/material/ListItemButton';
import type {ListItemButtonProps as MaterialListItemButtonProps} from '@mui/material/ListItemButton';
import {styled} from '@mui/material/styles';

export interface ListItemButtonProps extends MaterialListItemButtonProps {
    /**
     * Used to replace root node with different
     * component.
     */
    component?: React.ElementType<any>;
}

const StyledListItemButton = styled(MaterialListItemButton)<ListItemButtonProps>(({theme}) => ({
    '&:active': {
        backgroundColor: theme.tokens.FuelColorBackgroundActionDefaultPressed
    },
    '&.Mui-focusVisible': {
        backgroundColor: 'transparent',
        boxShadow: `inset 0 0 0 2px ${theme.tokens.FuelColorGray1000}`
    },
    '&.Mui-selected': {
        backgroundColor: theme.tokens.FuelColorBackgroundActionDefaultSelected,
        color: theme.tokens.FuelColorBrandPrimary,
        '&.Mui-focusVisible': {
            backgroundColor: 'transparent'
        },
        '& .MuiListItemIcon-root': {
            color: 'currentColor'
        },
        '&:hover': {
            backgroundColor: theme.tokens.FuelColorBackgroundActionDefaultSelected
        },
        '&:active': {
            backgroundColor: theme.tokens.FuelColorBackgroundActionDefaultSelected
        },
        '&:before': {
            content: '""',
            position: 'absolute',
            width: '3px',
            height: '100%',
            left: 0,
            top: 0,
            backgroundColor: theme.tokens.FuelColorBackgroundActionDefaultSelectedBar
        }
    }
}));

export const ListItemButton = React.forwardRef<any, ListItemButtonProps>(
    (
        {
            children,
            ...props
        },
        ref
    ) => {
        return (
            <StyledListItemButton
                ref={ref}
                {...props}
            >
                {children}
            </StyledListItemButton>
        );
    });

ListItemButton.displayName = 'ListItemButton';
